/**
 * The tab row a page shows under its header title, to split it into parts
 * (Time, Planner, Reports, Settings, Expenses). Each tab is an outlined pill so
 * the row reads as a set of choices even with only two. The selected one is
 * tinted, not filled: solid accent is kept for buttons that do something.
 */

export function HeaderTabs<T extends string>({ value, options, onChange }: {
  value: T; options: [T, string][]; onChange: (v: T) => void;
}) {
  return (
    <div role="tablist" style={{ display: "flex", gap: 6, width: "fit-content", maxWidth: "100%", overflowX: "auto", padding: 1 }}>
      {options.map(([key, text]) => {
        const on = key === value;
        return (
          <button key={key} role="tab" aria-selected={on} onClick={() => onChange(key)} style={{
            padding: "6px 14px", fontSize: 13, cursor: "pointer", whiteSpace: "nowrap", borderRadius: 999,
            border: `1px solid ${on ? "var(--accentSoft)" : "var(--line2)"}`,
            background: on ? "var(--accentTint)" : "var(--surface)",
            color: on ? "var(--accentDark)" : "var(--ink2)",
            fontWeight: on ? "var(--fw-title)" : "var(--fw-medium)",
          }}>{text}</button>
        );
      })}
    </div>
  );
}
